export default {
    DETACHED: 'detached',
    SEMI_DETACHED: 'semi-detached',
    TRIPLEX: 'triplex',
    DUPLEX_UP_DOWN: 'duplex-up-down',
    SIDE_DUPLEX: 'side-duplex',
    TOWNHOUSE: 'townhouse',
    ROW_HOUSE: 'row-house',

    HIGH_RISE_APARTMENT: 'high-rise-apartment',
    LOW_RISE_APARTMENT: 'low-rise-apartment',
    BASEMENT_APARTMENT: 'basement-apartment',
    DUPLEX: 'duplex',
    END_ROW_HOUSE: 'end-row-house',
    INSIDE_ROW_HOUSE: 'inside-row-house',
};
